module.exports = __webpack_public_path__ + "img/success-icon.c3f7d32f.png";